import React, {useEffect, useState} from 'react';
import './TransactionWidget.scss';
import {useTranslation} from 'react-i18next';
import Button from "../../components/Buttons/Button/Button";
import SwitchButton from "../../components/Buttons/SwitchButton/SwitchButton";
import {RequestWallet} from "../../request/RequestWallet";
import {Auth} from "../../utils/Auth";
import {isValidDecimal, isValidInteger, round} from "../../utils/services";
import routes from "../../utils/routes.json"
import {useNavigate} from "react-router-dom";
import OrderValidation from "../OrderValidation/OrderValidation";
import {RequestAutomation} from "../../request/RequestAutomation";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNotification } from "../NotificationContext/NotificationContext";
import { CircularProgress } from '@mui/material';
const TransactionWidget = ({ticker, price}) => {
    const {t} = useTranslation();
    const router = useNavigate();
    const requestAutomation = new RequestAutomation();
    const requestWallet = new RequestWallet();
    const [dataStock, setDataStock] = useState({})
    const [wallet, setWallet] = useState({})
    const [ownedQuantity, setOwnedQuantity] = useState(0);
    const [quantity, setQuantity] = useState("");
    const [openModal, setOpenModal] = useState(false)
    const [summaryData, setSummaryData] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [deletingAutomationId, setDeletingAutomationId] = useState(null);
    const transactionTypes = {
        BUY: t('transactionWidget.buy'),
        SELL: t('transactionWidget.sell')
    };
    const [transactionType, setTransactionType] = useState(transactionTypes.BUY);
    const [isAuth, setIsAuth] = useState(false)
    const auth = new Auth()
    const notificationService = useNotification();
    const [calcAmount, setCalcAmount] = useState(0)
    const [isProcessing, setIsProcessing] = useState(false)
    const orderTypes = {
        ORDER_MARKET: t('transactionWidget.marketOrder'),
        ORDER_STOP: t('transactionWidget.stopOrder'),
        INVESTMENT_PLANNING: transactionType === transactionTypes.BUY ? t('transactionWidget.investmentPlanning_buy') : t('transactionWidget.investmentPlanning_sell')
    }
    const [orderType, setOrderType] = useState(orderTypes.ORDER_MARKET)
    const [stopPrice, setStopPrice] = useState(0)
    const recurrences = {
        WEEKLY: t('transactionWidget.weekly'),
        MONTHLY: t('transactionWidget.monthly')
    }
    const [recurrence, setRecurrence] = useState(recurrences.WEEKLY);
    const typeOrders = {
        ABOVE: t('transactionWidget.above'),
        BELOW: t('transactionWidget.below')
    }
    const [typeOrder, setTypeOrder] = useState(typeOrders.ABOVE);
    const [isReadyReview, setReadyReview] = useState(false)
    const errors = {
        ERROR_BALANCE: t('transactionWidget.errors.insufficient_balance'),
        ERROR_TITLES: t('transactionWidget.errors.insufficient_titles'),
    }
    const [error, setError] = useState()
    const [automations, setAutomations] = useState([])

    async function fetchData() {
        const stockPerformance = await requestWallet.getStockPerformance(ticker);
        const getWallet = await requestWallet.getWallet();
        setWallet(getWallet.data)
        if (stockPerformance === 0) {
            setOwnedQuantity(0)
            setTransactionType(transactionTypes.BUY)
        } else {
            setOwnedQuantity(stockPerformance.data.quantity)
            setDataStock(stockPerformance.data)
        }
    }

    async function fetchAutomation(){
        const resp = await requestAutomation.getAutomation();
        let liste_automations = []
        if (resp.data){
            const liste_aux = resp.data.automations
            liste_aux.map((item)=>{
                if(item.ticker === ticker){
                    let order = {}
                    order.id = item.id;
                    if (item.type && item.type.toUpperCase() === "PRICE_THRESHOLD") {
                        order[t("transactionWidget.orderType")] = t("transactionWidget.stopOrder")
                        if (item.transactionType && item.transactionType.toUpperCase() === "BUY") {
                            order[t("transactionWidget.transactionType")] = transactionTypes.BUY
                        } else {
                            order[t("transactionWidget.transactionType")] = transactionTypes.SELL
                        }
                        order[t('transactionWidget.thresholdType')] = t(`transactionWidget.${item.thresholdType.toLowerCase()}`)
                        order[t('transactionWidget.quantity')] = item.quantity
                        order[t('transactionWidget.stopPrice')] = item.thresholdPrice
                    }else{
                        const isBuy = item.transactionType && item.transactionType.toUpperCase() === "BUY";
                        order[t("transactionWidget.orderType")] = isBuy ? t("transactionWidget.investmentPlanning_buy") : t("transactionWidget.investmentPlanning_sell");
                        if(isBuy){
                            order[t("transactionWidget.transactionType")] = transactionTypes.BUY
                        }else{
                            order[t("transactionWidget.transactionType")] = transactionTypes.SELL
                        }
                        order[t('transactionWidget.quantity')] = item.quantity || item.buyQuantity || item.quantite || 0;
                        const freq = item.frequency || item.frequence || item.recurrence || '';
                        order[t('transactionWidget.frequency')] = freq ? t(`transactionWidget.${freq.toLowerCase()}`) : ''
                    }
                    liste_automations.push(order)
                }
            })
            setAutomations(liste_automations);
        }
    }

    async function loadData() {
        setIsLoading(true);
        await Promise.all([
            fetchData(),
            fetchAutomation()
        ]);
        setIsLoading(false);
    }

    async function handleDeleteAutomation(id) {
        setDeletingAutomationId(id);
        try {
            await requestAutomation.deleteAutomation(id);
            notificationService.notify(t('transactionWidget.success_delete_automation'), 'success');
            await loadData();
        } catch (e) {
            notificationService.notify(t('transactionWidget.error_transaction'), 'error');
        } finally {
            setDeletingAutomationId(null);
        }
    }

    useEffect(() => {
        async function init() {
            if (auth.isLoggedIn()) {
                setIsAuth(true)
                await loadData();
            } else {
                setIsAuth(false)
                setIsLoading(false)
            }
        }
        init()
    }, [ticker]);

    useEffect(() => {
        if (transactionType === transactionTypes.BUY) {
            if (orderType === orderTypes.ORDER_STOP) {
                setReadyReview(isValidInteger(quantity) && isValidDecimal(stopPrice) && calcAmount <= wallet.solde)
            } else if (orderType === orderTypes.ORDER_MARKET) {
                setReadyReview(isValidInteger(quantity) && calcAmount <= wallet.solde)
            } else if (orderType === orderTypes.INVESTMENT_PLANNING) {
                setReadyReview(isValidInteger(quantity) && calcAmount <= wallet.solde)
            }
            if (calcAmount > wallet.solde) {
                setError(errors.ERROR_BALANCE)
            } else {
                setError("")
            }
        } else {
            if (orderType === orderTypes.ORDER_STOP) {
                setReadyReview(isValidInteger(quantity) && isValidDecimal(stopPrice) && ownedQuantity >= quantity)
            } else if (orderType === orderTypes.ORDER_MARKET) {
                setReadyReview(isValidInteger(quantity) && ownedQuantity >= quantity)
            } else if (orderType === orderTypes.INVESTMENT_PLANNING) {
                setReadyReview(isValidInteger(quantity) && ownedQuantity >= quantity)
            }
            if (ownedQuantity < quantity) {
                setError(errors.ERROR_TITLES)
            } else {
                setError("")
            }
        }

    }, [quantity, stopPrice, ticker])

    const handleClick = (type) => {
        if (orderType === orderTypes.INVESTMENT_PLANNING) {
            setOrderType(type === transactionTypes.BUY ? t('transactionWidget.investmentPlanning_buy') : t('transactionWidget.investmentPlanning_sell'));
        }
        setTransactionType(type);
    };

    const handleInputQttChange = (value) => {
        setQuantity(value)
        if (orderType === orderTypes.ORDER_MARKET || orderType === orderTypes.INVESTMENT_PLANNING) {
            setCalcAmount(round(value * price, 2))
        } else {
            setCalcAmount(round(value * stopPrice, 2))
        }
    }

    const handleInputStopPriceChange = (value) => {
        setStopPrice(value)
        setCalcAmount(round(quantity * value, 2))

    }
    const handleSelectChange = (value) => {
        setOrderType(value)
    }

    const handleRadioChange = (event) => {
        setRecurrence(event.target.value);
    };

    const handleSelectOrderChange = (event) => {
        setTypeOrder(event);
    };


    async function transaction() {
        setIsProcessing(true);
        try {
            let successMessage = t('transactionWidget.success_transaction');
            if (orderType === orderTypes.ORDER_MARKET) {
                if (transactionType === transactionTypes.BUY) {
                    await requestWallet.acheter(ticker, quantity);
                    successMessage = t('transactionWidget.success_market_buy', { quantity });
                } else {
                    await requestWallet.vendre(ticker, quantity);
                    successMessage = t('transactionWidget.success_market_sell', { quantity });
                }
            } else if (orderType === orderTypes.INVESTMENT_PLANNING) {
                await requestAutomation.dcaAutomation(ticker, parseFloat(quantity), recurrence === recurrences.WEEKLY ? "WEEKLY" : "MONTHLY", transactionType === transactionTypes.BUY ? "BUY" : "SELL");
                successMessage = t('transactionWidget.success_automation');
            } else if (orderType === orderTypes.ORDER_STOP) {
                await requestAutomation.pricethresholdAutomation(ticker, parseFloat(stopPrice), transactionType === transactionTypes.BUY ? "BUY" : "SELL", typeOrder === typeOrders.ABOVE ? "ABOVE" : "BELOW", parseFloat(quantity));
                successMessage = t('transactionWidget.success_limit_order');
            }
            
            notificationService.notify(successMessage, 'success');
            setOpenModal(false);
            resetValues();
            await loadData();
        } catch (e) {
            notificationService.notify(t('transactionWidget.error_transaction'), 'error');
        } finally {
            setIsProcessing(false);
        }
    }    function getSummary() {
        setOpenModal(true)
        let newSummaryData = {
            [t('transactionWidget.transactionType')]: transactionType,
            [t('transactionWidget.orderType')]: orderType,
            [t('transactionWidget.quantity')]: quantity
        }
        
        const amountKey = transactionType === transactionTypes.BUY ? t('transactionWidget.amount_buy') : t('transactionWidget.amount_sell');
        
        if (orderType === orderTypes.ORDER_MARKET) {
            newSummaryData[amountKey] = calcAmount + "$"
        } else if (orderType === orderTypes.ORDER_STOP) {
            newSummaryData[t('transactionWidget.stopOrder')] = stopPrice
            newSummaryData[amountKey] = calcAmount + "$"

        } else {
            newSummaryData[t('transactionWidget.recurrence')] = recurrence
        }
        setSummaryData(newSummaryData)
    }

    function resetValues() {
        setQuantity(0)
        setStopPrice(0)
        setCalcAmount(0)
        setOrderType(orderTypes.ORDER_MARKET)
    }

    function cancelTransaction() {
        setOpenModal(false)
        resetValues()
    }

    return (
        <div className="w-100">
            {isLoading ?
                <div className="w-100">
                    <div className="skeleton w-100 mb-3" style={{height: 40, borderRadius: 20}}></div>
                    <div className="skeleton mb-4 mx-auto" style={{height: 20, width: '60%'}}></div>
                    <div className="d-flex mb-4" style={{gap: '8px'}}>
                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                    </div>
                    <div className="skeleton w-100 mb-4" style={{height: 60, borderRadius: 12}}></div>
                    <div className="skeleton w-100 mb-4" style={{height: 60, borderRadius: 12}}></div>
                    <div className="skeleton w-100 mt-5" style={{height: 50, borderRadius: 12}}></div>
                </div>
                :
                <div className="w-100 containerTransactionWidget">
                    {isAuth ?
                        openModal ? <OrderValidation data={summaryData} cancel={cancelTransaction}
                                                     transaction={transaction} isProcessing={isProcessing}/> :
                            <>
                                <div className="segmented-control w-100 mb-3">
                                    <div
                                        className={`segmented-btn ${transactionType === transactionTypes.BUY ? 'active' : ''}`}
                                        onClick={() => handleClick(transactionTypes.BUY)}
                                    >
                                        {transactionTypes.BUY}
                                    </div>
                                    {ownedQuantity !== 0 && (
                                        <div
                                            className={`segmented-btn ${transactionType === transactionTypes.SELL ? 'active' : ''}`}
                                            onClick={() => handleClick(transactionTypes.SELL)}
                                        >
                                            {transactionTypes.SELL}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3 text-gray text-center font-bold">
                                    {transactionType === transactionTypes.BUY ?
                                        `${round(wallet.solde, 2)}$ ${t('transactionWidget.available')}`
                                        :
                                        ownedQuantity !== 0 &&
                                        `${dataStock.quantity} ${t('transactionWidget.sharesOwned')}`
                                    }
                                </div>

                                <div className="order-type-tabs mb-4">
                                    {Object.values(orderTypes).map(type => (
                                        <div key={type} 
                                             className={`order-tab ${orderType === type ? 'active' : ''}`}
                                             onClick={() => handleSelectChange(type)}>
                                            {type}
                                        </div>
                                    ))}
                                </div>

                                <label className="input-row mt-4" style={{cursor: 'pointer'}}>
                                    <div className="input-label">{t('transactionWidget.quantity')}</div>
                                    <div className="input-field">
                                        <input type="number" min="0" value={quantity || ''} onChange={(e) => handleInputQttChange(parseInt(e.target.value) || 0)} placeholder="0" />
                                    </div>
                                </label>

                                {orderType === orderTypes.ORDER_STOP && (
                                    <>
                                        <div className="input-row mt-3">
                                            <div className="input-label">{t('transactionWidget.thresholdType')}</div>
                                            <div className="input-field d-flex justify-end">
                                                <SwitchButton 
                                                    className="m-0"
                                                    leftLabel={typeOrders.ABOVE}
                                                    rightLabel={typeOrders.BELOW}
                                                    onClickLeft={() => handleSelectOrderChange(typeOrders.ABOVE)}
                                                    onClickRight={() => handleSelectOrderChange(typeOrders.BELOW)}
                                                />
                                            </div>
                                        </div>
                                        <label className="input-row mt-3" style={{cursor: 'pointer'}}>
                                            <div className="input-label">{t('transactionWidget.stopPrice')}</div>
                                            <div className="input-field">
                                                <input type="number" step="0.01" min="0" value={stopPrice || ''} onChange={(e) => handleInputStopPriceChange(parseFloat(e.target.value) || 0)} placeholder="0.00" />
                                            </div>
                                        </label>
                                        <div className="thresholdDef mt-2 mb-2">
                                            {t('transactionWidget.thresholdDef')}
                                        </div>
                                    </>
                                )}

                                {orderType === orderTypes.INVESTMENT_PLANNING && (
                                    <div className="input-row mt-3">
                                        <div className="input-label">{t('transactionWidget.frequency')}</div>
                                        <div className="input-field d-flex justify-end">
                                            <SwitchButton 
                                                className="m-0"
                                                leftLabel={recurrences.WEEKLY}
                                                rightLabel={recurrences.MONTHLY}
                                                onClickLeft={() => setRecurrence(recurrences.WEEKLY)}
                                                onClickRight={() => setRecurrence(recurrences.MONTHLY)}
                                            />
                                        </div>
                                    </div>
                                )}

                                {orderType !== orderTypes.INVESTMENT_PLANNING && (
                                    <div className="summary-block mt-4">
                                        <div className="summary-row">
                                            <span>{transactionType === transactionTypes.BUY ? t('transactionWidget.amount_buy') : t('transactionWidget.amount_sell')}</span>
                                            <span className="summary-value">{`${calcAmount}$`}</span>
                                        </div>
                                    </div>
                                )}

                                <div className="mt-4 containerButton w-100 d-flex flex-column align-center justify-center">
                                    <div className="error mb-2">{error}</div>
                                    <Button styles={isReadyReview ? "button black w-100 py-3" : "button notValid w-100 py-3"}
                                            handleClick={isReadyReview ? getSummary : null}
                                            children={t('transactionWidget.reviewOrder')}/>
                                </div>

                                {ownedQuantity !== 0 && (
                                    <div className="containerPosition mt-5 pt-4" style={{ borderTop: '1px solid #f1f5f9' }}>
                                        <h2 className="mb-3" style={{ fontSize: '1.1rem' }}>{t('transactionWidget.position')}</h2>
                                        <div className="position-grid">
                                            <div className="position-block">
                                                <div className="label">{t('transactionWidget.total')}</div>
                                                <div className="val">{round(dataStock.buyPrice * dataStock.quantity, 2)}$</div>
                                            </div>
                                            <div className="position-block">
                                                <div className="label">{t('transactionWidget.performance')}</div>
                                                <div className={`val ${dataStock.performance && dataStock.performance.percentage >= 0 ? 'text-green' : 'text-red'}`}>
                                                    {dataStock.performance !== undefined && `${dataStock.performance.percentage}`}
                                                </div>
                                            </div>
                                            <div className="position-block">
                                                <div className="label">{t('transactionWidget.quantity')}</div>
                                                <div className="val">{dataStock.quantity}</div>
                                            </div>
                                            <div className="position-block">
                                                <div className="label">{t('transactionWidget.buyIn')}</div>
                                                <div className="val">{`${round(dataStock.buyPrice, 2)}$`}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {automations.length !== 0 && (
                                    <div className="automations-section mt-5 pt-4" style={{ borderTop: '1px solid #f1f5f9' }}>
                                        <h2 className="mb-3" style={{fontSize: '1.1rem'}}>{t('wallet.ordersPlaced')}</h2>
                                        <div className="automations-list">
                                            {automations.map((item, idx) => (
                                                <div key={idx} className={`automation-card mb-3 ${deletingAutomationId === item.id ? 'deleting-non-optimistic' : ''}`}>
                                                    <div className="auto-header d-flex align-center">
                                                        <span className={`auto-badge ${item[t("transactionWidget.transactionType")] === transactionTypes.BUY ? 'buy' : 'sell'}`}>
                                                            {item[t("transactionWidget.transactionType")]}
                                                        </span>
                                                        <span className="auto-type font-bold ml-3" style={{ flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {item[t("transactionWidget.orderType")]}
                                                        </span>
                                                        <div className="ml-2 d-flex align-center justify-center">
                                                            {deletingAutomationId === item.id ? (
                                                                <CircularProgress size={18} style={{ color: '#cbd5e1' }} />
                                                            ) : (
                                                                <DeleteOutlineRoundedIcon 
                                                                    titleAccess={t('transactionWidget.deleteOrder')}
                                                                    onClick={() => handleDeleteAutomation(item.id)} 
                                                                    sx={{ color: '#ef4444', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { color: '#dc2626', transform: 'scale(1.1)' } }} 
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="auto-details">
                                                        <div className="auto-data">
                                                            <span className="data-label">{t('transactionWidget.quantity')}</span>
                                                            <span className="data-value">{item[t('transactionWidget.quantity')]}</span>
                                                        </div>
                                                        {item[t('transactionWidget.stopPrice')] && (
                                                            <div className="auto-data">
                                                                <span className="data-label">{t('transactionWidget.stopPrice')}</span>
                                                                <span className="data-value">{item[t('transactionWidget.stopPrice')]}$</span>
                                                            </div>
                                                        )}
                                                        {item[t('transactionWidget.frequency')] && (
                                                            <div className="auto-data">
                                                                <span className="data-label">{t('transactionWidget.frequency')}</span>
                                                                <span className="data-value">{item[t('transactionWidget.frequency')]}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                            </> :
                        <div className="logged-out-state mt-5 text-center d-flex flex-column align-center justify-center" style={{ padding: '24px 16px' }}>
                            <div className="icon-circle mb-3" style={{ backgroundColor: '#f1f5f9', padding: '16px', borderRadius: '50%', display: 'inline-flex' }}>
                                <LockOutlinedIcon sx={{ fontSize: 32, color: '#94a3b8' }} />
                            </div>
                            <h3 className="mb-2" style={{ color: '#0f172a', fontSize: '1.1rem', lineHeight: '1.5' }}>{t('transactionWidget.logInSentence')}</h3>
                            <div className="mt-4 w-100 px-4">
                                <Button styles="button black w-100 py-3" handleClick={() => router(routes.auth, {state: routes.login})}>
                                    {t('login.connect')}
                                </Button>
                            </div>
                        </div>
                    }

                </div>
            }
        </div>

    );
};

export default TransactionWidget;
